import { gql } from '@apollo/client';

export const UNSAVE_FLYER_MUTATION = gql`
  mutation unsaveFlyers($input: UnsaveFlyersInput!) {
    unsaveFlyers(input: $input) {
      success
    }
  }
`;
